import React from 'react';
import { ApiStatusView } from '../components/ApiStatusView';
import { isHostLocal, isHostProduction } from '../api/constants';
import { CheckCircleIcon, WarningTwoIcon } from '@chakra-ui/icons';
export var ApiStatus = function () {
    var host = isHostLocal
        ? 'local'
        : isHostProduction
            ? 'production'
            : 'staging';
    var status = isHostLocal ? 'error' : 'success';
    var icon = isHostLocal ? React.createElement(WarningTwoIcon, null) : React.createElement(CheckCircleIcon, null);
    var message = "Your APIs are connected to " + host;
    return React.createElement(ApiStatusView, { message: message, status: status, icon: icon });
};
